import(/* webpackMode: "eager" */ "/usr/src/app/src/app/[locale]/page.tsx");
